import React, { useState } from 'react';
import { CustomSelectComponent, FormCol, FsProps } from 'motion-components';
import { Field } from 'formik';
import { gql, useQuery } from '@apollo/client';

export const gqlGetPrinters = gql`
  query getPrinters {
    getPrinters {
      name
    }
  }
`;

export const FieldSelectPrinter = ({ label = 'Εκτυπωτής', name = 'printer', defaultValues = {}, ...rest }: FsProps) => {
  useQuery(gqlGetPrinters, {
    fetchPolicy: 'network-only',
    onCompleted(data) {
      const printers = data.getPrinters.map((printer) => {
        return { value: printer.name, label: printer.name };
      });
      setOptions(printers);
    },
  });
  const [options, setOptions] = useState([]);
  return <Field {...rest} title={'Εκτυπωτής'} name={'printer'} component={CustomSelectComponent} options={options} />;
};

